export default "__VITE_ASSET__BaZG1Vm6__"